import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import axios from "axios";
import { webView } from "../variables/webView";
import { getCookie, isNoEditRoute } from "./helpers";
import useIsNoIframe from "./useIsNoIframe";

function useTypeDecription() {
  const change = useSelector((state) => state.changeLang.change);

  const [content, setContent] = useState(null);
  const [typeCard, setTypeCard] = useState(null);
  const { isNoIframe } = useIsNoIframe();

  const getContent = (typeCard) => {
    if (!isNoIframe || !isNoEditRoute) {
      return;
    }
    setTypeCard(typeCard)
    const description = document.querySelector("#description");
    if (!description && !webView) {
      const locale = change === "en" ? "" : `/${change}`;
      axios(`${locale}/get_generator_second_step/${typeCard}`).then(
        ({ data }) => {
          const article = parse(data.twigArticle).props.children.find(
            (item) => item?.type && item?.props?.className === "container"
          );
          const raiting = parse(data.twigRating);
          const combinedContent = [article, raiting].map((item, index) => ({
            ...item,
            key: index,
          }));
          setContent(combinedContent);
          setTimeout(() => showFooter(), 500);

        }
      );
    }
  };
  useEffect(() => {
    if (!typeCard) return;
    const locale = change === "en" ? "" : `/${change}`;

    axios(`${locale}/get_generator_second_step/${typeCard}`).then(({ data }) => {
      if (!data.articleData) return;

      const articleBlock = document.getElementById("article-generator-block");
      if (!articleBlock) return;

      articleBlock.innerHTML = `
      <div class="col-lg-2 col-4 px-0 overflow-hidden">
          <img src="${data.articleData.previewImage}"
               loading="lazy" class="img-fluid" alt="${data.articleData.title}">
      </div>
      <div class="col-lg-6 col-8 ps-3 pe-lg-0 pe-3 ">
          <p class="fw-bold mb-lg-0 py-lg-3 articleTitle">
            ${data.articleData.title.length < 60
        ? data.articleData.title
        : data.articleData.title.slice(0, 60) + "..."}
          </p>
          <a class="btn btn-primary fw-bold py-lg-3 w-100 py-1 fs-7 d-lg-none"
             href="${locale}/page/${data.articleData.typeUrl}/${data.articleData.url}">
             Read More
          </a>
      </div>
      <div class="col-4 pe-4 ps-5 d-none d-lg-block">
          <a class="btn btn-primary fw-bold py-3 w-100"
             href="${locale}/page/${data.articleData.typeUrl}/${data.articleData.url}">
             Read More
          </a>
      </div>`;

      if (!data.youtubeVideoData) return;

      const videoBlock = document.getElementById("video-wrapper");
      if (!videoBlock) return;

      const embedUrl = data.youtubeVideoData.url.replace("watch?v=", "embed/");

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            videoBlock.innerHTML = `
            <iframe
              src="${embedUrl}"
              frameborder="0"
              allowfullscreen>
            </iframe>`;
            obs.disconnect();
          }
        });
      });

      observer.observe(videoBlock);
    });
  }, [change, typeCard]);

  useEffect(() => {
    if (!content && !document.getElementById("ratingBlock")) {
      return;
    }
    const beforeVote = document.getElementById("beforeVote");
    const afterVote = document.getElementById("afterVote");
    const showRating = document.getElementById("showRating");
    const ratingGroup = document.getElementById("ratingGroup");
    const averageRating = document.getElementById("averageRating");
    const noRatingDescription = document.getElementById("noRatingDescription");
    const showRatingPercent = document.getElementById("showRatingPercent");

    const handleSubmit = () => {
      const selectedStar = document.querySelector('input[name="fst"]:checked');
      const selectedStars = selectedStar.value;
      const page = window.location.href.split("/");
      const pageType = page[page.length - 1];
      if (typeof selectedStars !== "string") {
        return;
      }

      ratingGroup.classList.add("d-none");
      averageRating.classList.remove("d-none");
      noRatingDescription.classList.add("d-none");
      showRating.classList.remove("d-none");
      afterVote.classList.remove("d-none");
      beforeVote.classList.add("d-none");
      axios
        .post(`/rating/generator/${pageType}`, {
          rating: selectedStars,
        })
        .then((response) => {
          const data = response.data.ratingData;
          const avg = Number(data.averageRating);
          const votes = Number(data.totalVotes);
          const adjusted = 4 + (avg - 1) / 3;
          const percent = avg * 20;
          const adjustedPercent = adjusted * 20;

          if (avg < 4 && votes > 5) {
            averageRating.textContent = `${averageRating.dataset.average} ${adjusted.toFixed(1)}/5 ${averageRating.dataset.votes} ${votes}`;
            showRatingPercent.style.left = `${adjustedPercent}%`;
          } else {
            averageRating.textContent = `${averageRating.dataset.average} ${avg.toFixed(1)}/5 ${averageRating.dataset.votes} ${votes}`;
            showRatingPercent.style.left = `${percent}%`;
          }

          setCookie(`hasVoted_${pageType}`, "true", 365);
        })
        .catch((error) => {
          console.error(error);
        });

    };

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }

      document.cookie = `${name}=${
        value || ""
      }${expires}; path=/; SameSite=Lax`;
    }

    function check() {
      const page = window.location.href.split("/");
      const pageType = page[page.length - 1];
      const hasVoted = getCookie(`hasVoted_${pageType}`);
      const selectedStar = document.querySelector('input[name="fst"]:checked');

      if (hasVoted === "true") {
        afterVote.classList.remove("d-none");
        showRating.classList.remove("d-none");
        averageRating.classList.remove("d-none");
        beforeVote.classList.add("d-none");
        ratingGroup.classList.add("d-none");
        noRatingDescription.classList.add("d-none");
      } else {
        if (selectedStar) {
          selectedStar.checked = true;
        }
        beforeVote.classList.remove("d-none");
        noRatingDescription.classList.remove("d-none");
        afterVote.classList.add("d-none");
        showRating.classList.add("d-none");
        averageRating.classList.add("d-none");
      }
    }

    if (!ratingGroup.dataset.eventBound) {
      ratingGroup.addEventListener("change", handleSubmit);
      // submitButton.addEventListener("click", handleSubmit);
      ratingGroup.dataset.eventBound = "true";
    }
    check();

    return () => {
      ratingGroup.removeEventListener("change", handleSubmit);
      // submitButton.removeEventListener("click", handleSubmit);
    };
  }, [content]);

  const pasteBottomDescription = () => {
    document
      .querySelector("#description")
      ?.classList.remove("position-absolute");
  };
  const pasteTemplates = () => {
    document
      .querySelector("#templateGeneratorPageBlock")
      ?.classList.remove("template-generator-page-block");
  };
  const removeDescription = () => {
    document.querySelector("#description")?.remove();
  };
const removeTemplates = () => {
    document.querySelector("#templateGeneratorPageBlock")?.remove();
  };

  const showFooter = () => {
    if (!webView) {
      document.querySelector("#footer")?.classList.remove("d-none");
    }
  };

  const hideFooter = () => {
    document.querySelector("#footer")?.classList.add("d-none");
  };

  const removeFirstPageTitle = () => {
    document.querySelector("#firstStepTitle")?.remove();
  };

  return {
    content,
    getContent,
    pasteBottomDescription,
    removeDescription,
    removeTemplates,
    showFooter,
    hideFooter,
    pasteTemplates,
    removeFirstPageTitle,
  };
}
export default useTypeDecription;
